query PaymentTrackingTypes {
  paymentTransactionTypes {
    nodes {
      transactionType
      id
    }
  }
  companyBusinessUnits {
    nodes {
      id
      name
    }
  }
  companyCurrencies {
    nodes {
      id
      name
    }
  }
    companies(orderBy: NAME_ASC) {
    nodes {
      id
      name
    }
  }
  invoiceStatusTypes {
    nodes {
      id
      statusType
    }
  }
}
